export const SERVICES = [
  {
    title: "Software Development",
    intro: "Custom web, cloud and enterprise software engineered for performance and scalability.",
    items: ["Full Stack Applications", "Cloud Native Solutions", "REST APIs", "Enterprise Dashboards"],
  },
  {
    title: "AI Applications",
    intro: "Intelligent AI systems that automate workflows and accelerate business growth.",
    items: ["AI Agents & Chatbots", "Computer Vision", "Predictive Analytics", "Workflow Automation"],
  },
  {
    title: "Internship Programs",
    intro: "Industry-focused internships with live projects and expert mentorship.",
    items: ["Live Projects", "Industry Mentors", "Skill Assessments", "Placement Guidance"],
  },
  {
    title: "IT Infrastructure",
    intro: "Reliable networking and secure digital infrastructure for modern businesses.",
    items: ["Network Design", "Server Deployment", "Cloud Connectivity", "Security Hardening"],
  },
  {
    title: "Data Analytics",
    intro: "Transform business data into actionable insights with intelligent analytics.",
    items: ["KPI Dashboards", "Power BI Integration", "Predictive Reports", "Data Warehousing"],
  },
  {
    title: "Certified IT Solutions",
    intro: "Professional IT solutions delivered with quality, security and reliability.",
    items: ["Quality Assurance", "Secure Development", "Performance Optimization", "Technical Support"],
  },
];

export const STEPS = [
  {
    step: "01",
    title: "Apply Online",
    desc: "Fill out the internship application on our platform. Our team reviews your profile and confirms eligibility within 24 hours.",
  },
  {
    step: "02",
    title: "Receive Offer Letter",
    desc: "Once shortlisted, you receive an official Internship Offer Letter from Scontinent Technologies confirming your placement.",
  },
  {
    step: "03",
    title: "Start Training",
    desc: "Begin hands-on training and live project work under expert mentors. Build real skills with 80% practical experience.",
  },
  {
    step: "04",
    title: "Get Certified",
    desc: "After successful completion, receive your Scontinent Internship Certificate — a verified credential recognised by colleges and companies.",
  },
];

export const WHY_US = [
  { title: "Real-World Experience", desc: "Work on actual industry projects from day one." },
  { title: "Professional Development", desc: "Mentorship, workshops, and career guidance." },
  { title: "Networking Opportunities", desc: "Build valuable connections with industry experts." },
  { title: "20% Theory & 80% Practical", desc: "Learn by doing — deeply skill-focused training." },
];

export const CERT_BENEFITS = [
  {
    title: "Demonstrate Expertise",
    desc: "Our certification is credible proof of your hands-on experience and technical skills. It validates your expertise to employers.",
  },
  {
    title: "Global Recognition",
    desc: "Scontinent certifications are accepted by companies and universities globally, enhancing your professional credibility.",
  },
  {
    title: "Career Advancement",
    desc: "Certified interns gain a strong competitive edge in placements. Employers prefer candidates with verified, practical experience.",
  },
  {
    title: "Higher Earning Potential",
    desc: "Certified professionals are offered higher salaries and faster career growth. Your certificate highlights specialised expertise.",
  },
];

export const TESTIMONIALS = [
  {
    quote:
      "Students often read without understanding. The first time I saw this app, I thought it was wonderful. For competitive exams, framing questions from paragraphs is essential, and this app helps with that.",
    name: "Garani N Krishnamurthy",
    role: "Economics Author",
    initials: "GK",
  },
  {
    quote:
      "AI is the best feature of your app with no parallel. I have seen many apps, and yours truly stands out. Your strength lies in accurate AI-generated reports. One aspect I liked is the detailed feedback highlighting strong and weak areas, which is unique. This feedback system is commendable and not seen in other apps.",
    name: "Shantappa Kurubara",
    role: "Police Sub-Inspector (644th UPSC Rank)",
    initials: "SK",
  },
  {
    quote:
      "As a React Native intern at Scontinent Technology, I immerse in cutting-edge mobile app development, gaining hands-on experience, collaborating on real projects, and honing skills in responsive interfaces. The internship cultivates innovation, continuous learning, and practical insights into the software development lifecycle.",
    name: "Sushma C K",
    role: "Student, DonBosco Institute of Technology",
    initials: "SC",
  },
  {
    quote:
      "Engaged in a 3-month manual testing internship at Scontinent Technologies, identifying software bugs, collaborating with developers, and gaining practical QA experience. Enhanced understanding of testing methodologies in a professional environment.",
    name: "Shashank K R",
    role: "Student, Channabasaveshwara Institute of Technology, Tumkur",
    initials: "SR",
  },
  {
    quote:
      "I have benefited greatly by getting an internship in Scontinent Company. Scontinent Company has provided a lot of convenience to the students and is a company that students like. I have completed an internship as a full stack developer here where the team taught me very well. The Scontinent app is very helpful for students — whether it's preparing for exams or getting an internship.",
    name: "Muddarange Gowda",
    role: "Student, Acharya Institute of Technology",
    initials: "MG",
  },
  {
    quote:
      "SamAI is a valuable app for NEET aspirants, offering AI-generated mock tests with detailed explanations for each question. The multilingual support enhances accessibility, catering to diverse users. This approach ensures comprehensive preparation and understanding, making it an essential tool for students aiming to excel in NEET.",
    name: "Meghana N",
    role: "IIT Dhanbad, Jharkhand",
    initials: "MN",
  },
  {
    quote:
      "Gaining valuable testing experience — collaborated on manual application testing, created bug lists, tested GraphQL APIs with Postman, and conducted load testing using JMeter. Enhanced technical skills and learned teamwork, commitment, and continuous improvement in software testing.",
    name: "Keerthi Patel",
    role: "Student, Acharya Institute of Technology",
    initials: "KP",
  },
  {
    quote:
      "I had a great experience working at Sconti. I learned many things — confidence, decision making, leadership qualities and much more. The team members are friendly and helped me build my technical skills, teamwork commitments and ways to improve in the testing team.",
    name: "Pavan D N",
    role: "Student, Acharya Institute of Technology",
    initials: "PD",
  },
  {
    quote:
      "As a Frontend Trainee intern at Scontinent Technologies Pvt Ltd, I found the experience highly valuable. The team's guidance and expertise significantly contributed to my professional growth. Overall, I'm grateful for the opportunity to learn and develop during my time at the company.",
    name: "Lakshmi Priya R",
    role: "Student, Acharya Institute of Technology",
    initials: "LP",
  },
];

export const FAQ = [
  {
    q: "How long are the internship programs?",
    a: "Our internship programs run for 1, 2, or 3–4 months depending on the domain and student availability, with an option to extend up to 6 months for select tracks.",
  },
  {
    q: "How do I apply for a Scontinent internship?",
    a: "Complete the Apply for Internship form on our website. Our team reviews profiles and confirms eligibility within 24 hours, followed by an official Offer Letter for shortlisted candidates.",
  },
  {
    q: "What do I get from the internship program?",
    a: "You gain real-world experience on live projects, mentorship from industry experts, 80% practical training, an official offer letter, and a verified completion certificate.",
  },
  {
    q: "What domains are available for internships?",
    a: "We offer 25+ technical and non-technical domains including AI/ML, Data Science, Full Stack, UI/UX, Cyber Security, Cloud & DevOps, Digital Marketing, Finance, HR and more.",
  },
  {
    q: "What certificates will I receive?",
    a: "Every intern receives the Scontinent Internship Certificate — a nationally recognised credential recognised by colleges and companies globally.",
  },
  {
    q: "How is performance evaluated?",
    a: "Interns are evaluated on live project deliverables, mentor feedback, skill assessments, and a final capstone review. Consistent high performers receive Letters of Recommendation.",
  },
  {
    q: "Is the internship paid or unpaid?",
    a: "Our flagship internship tracks are Paid programs. Specific stipend and fee details are shared with the Offer Letter after shortlisting.",
  },
];

export const STATS_HERO = [
  { value: "100,751+", label: "Students Interned" },
  { value: "5,263+", label: "Live Projects" },
  { value: "50+", label: "College MOUs" },
];

export const STATS_ABOUT = [
  { value: "100,751+", label: "Students Mentored" },
  { value: "15+", label: "Training Programs" },
  { value: "98%", label: "Success Rate" },
  { value: "25+", label: "Corporate Partners" },
];

export const STATS_IMPACT = [
  { value: "100,751+", label: "Happy Students" },
  { value: "5,263+", label: "Projects" },
  { value: "50+", label: "Colleges MOU" },
  { value: "15+", label: "Hard Workers" },
];

export const RECOGNITIONS = [
  { name: "Startup India", src: "/assets/startup-india.jpg" },
  { name: "MSME Registered", src: "/assets/msme.jpg" },
  { name: "Startup Karnataka", src: "/assets/startup-karnataka.jpg" },
  { name: "Visvesvaraya Technological University", src: "/assets/vtu-logo.png" },
];

export const PARTNERS = [
  { name: "BDG TRONIX", src: "/assets/bdg-tronix.jpg" },
  { name: "RefillBot", src: "/assets/refillbot.jpg" },
  { name: "Farmer by Nature", src: "/assets/farmer-by-nature.jpg" },
  { name: "Association of People with Disability", src: "/assets/apd.jpg" },
  { name: "SARUS Humanitarian Aerospace", src: "/assets/sarus.jpg" },
  { name: "rydoo", src: "/assets/rydoo.jpg" },
  { name: "PARYAAVARNEER", src: "/assets/paryaavarneer.jpg" },
  { name: "Interior Design", src: "/assets/interior-design.jpg" },
];

export const CONTACT = {
  address:
    "NO. 23, Mezzanine Floor, Outer Ring Rd, 2nd Block, 2nd Stage, Naagarabhaavi, Bengaluru, Karnataka 560072",
  phone: "+91 9353548879",
  email: "office@scontinent.com",
};
